import React from 'react';
import { motion } from 'framer-motion';
import Particles from 'react-tsparticles';
import { loadFull } from 'tsparticles';
import { ReactTyped } from 'react-typed'; 
import profileImg from '../assets/nigra photo.jpg'; // ✅ Ensure file name has no spaces

const Hero = () => {
  const particlesInit = async (main) => {
    await loadFull(main);
  };

  return (
    <section id="hero" className="min-h-screen relative flex items-center justify-center">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          background: { color: { value: "#0d1b2a" } },
          particles: {
            number: { value: 80, density: { enable: true, value_area: 800 } },
            color: { value: "#60a5fa" },
            shape: { type: "circle" },
            opacity: { value: 0.5 },
            size: { value: 3 },
            move: { enable: true, speed: 2, direction: "none", random: true }
          },
          interactivity: {
            events: { onhover: { enable: true, mode: "repulse" } }
          }
        }}
        className="absolute inset-0"
      />
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 1 }}
        className="relative z-10 text-center px-4"
      >
        <img
          src={profileImg}
          alt="Teerth Pandya"
          className="w-32 h-32 md:w-40 md:h-40 rounded-full mx-auto mb-6 border-4 border-blue-400 shadow-lg"
        />
        <h1 className="text-5xl md:text-7xl font-extrabold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
          Teerth Pandya
        </h1>
        <h2 className="text-2xl md:text-3xl mb-6">
          <span className="text-blue-400 font-semibold">
            <ReactTyped
              strings={['Full Stack Developer', 'React.js Expert', 'Web Innovator']}
              typeSpeed={60}
              backSpeed={40}
              loop
            />
          </span>
        </h2>
        <p className="max-w-2xl mx-auto text-gray-200 mb-8 text-lg">
          Transforming ideas into seamless, high-performance web experiences
        </p>
        <a
          href="#contact"
          className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 px-8 py-3 rounded-full text-lg font-medium transition-all duration-300 shadow-lg hover:shadow-xl"
        >
          Get in Touch
        </a>
      </motion.div>
    </section>
  );
};

export default Hero;
